import { FormattedMessage } from 'react-intl'
import { Box, Paper, styled, Tooltip } from '@mui/material'
import { Button, Typography } from '@carto/meridian-ds/components'
import { useAppDispatch, useAppSelector } from 'app/state'
import { RequestStatus } from 'features/common'
import ModalWrapper from 'features/common/ui/utils/ModalWrapper'
import QuotaStats from '../QuotaStats/QuotaStats'
import { HubspotForm } from 'features/hubspot/ui/HubspotForm/HubspotForm'
import { accountLimitRequest, setAccountLimitStatus } from 'features/hubspot/state/hubspotSlice'
import { QuotasRequestOptions } from 'features/hubspot/types'
import settings from 'settings'
import intl from 'app/localization/intl'

const Root = styled(Paper)(({ theme }) => ({
  maxWidth: theme.spacing(74),
  padding: theme.spacing(3, 3, 1)
}))

interface QuotaExceededModalProps {
  open: boolean
  quotasRequestType?: QuotasRequestOptions
  onCloseModal: () => void
}

function QuotaExceededModal({ open, onCloseModal, quotasRequestType }: QuotaExceededModalProps) {
  const dispatch = useAppDispatch()
  const accountLimitStatus = useAppSelector((state) => state.hubspot.accountLimitStatus)
  const showHubspotForm = accountLimitStatus !== RequestStatus.Idle

  const closeModal = () => {
    onCloseModal()
    dispatch(setAccountLimitStatus(RequestStatus.Idle))
  }

  return (
    <ModalWrapper open={open} displayCloseIcon={false} onCloseModal={closeModal}>
      <Root elevation={0}>
        <Box pb={3}>
          <Typography variant="h6">
            <FormattedMessage id="quotas.modal.title" />
          </Typography>
        </Box>
        {showHubspotForm ? (
          <Box height={(theme) => theme.spacing(36)}>
            <HubspotForm status={accountLimitStatus} onDone={closeModal} />
          </Box>
        ) : (
          <>
            <Box pb={3}>
              <Typography variant="body2" color="textSecondary">
                <FormattedMessage id="quotas.modal.subtitle" />
              </Typography>
            </Box>
            <Box py={2.5} px={3} sx={{ backgroundColor: (theme) => theme.palette.grey[50] }}>
              <QuotaStats />
            </Box>
            <Box mt={3} display="flex" justifyContent="flex-end">
              <Tooltip
                title={!settings.enableHubspot ? intl.formatMessage({ id: 'hubspot.hubspotDisabledAlert' }) : undefined}
              >
                <Box>
                  <Button
                    disabled={!settings.enableHubspot}
                    color="primary"
                    onClick={() =>
                      dispatch(accountLimitRequest(quotasRequestType || QuotasRequestOptions.ReachingQuotas))
                    }
                  >
                    <FormattedMessage id="common.button.wantToBeContacted" />
                  </Button>
                </Box>
              </Tooltip>
              <Button color="primary" onClick={onCloseModal}>
                <FormattedMessage id="common.button.done" />
              </Button>
            </Box>
          </>
        )}
      </Root>
    </ModalWrapper>
  )
}

export default QuotaExceededModal
